// ref: ondemand/react/reactUi/src/actions/trialRegistration/trialRegistration.js
const PING_DELAY_IN_MS = 1000;
export const MAX_PING_ATTEMPTS = 60;
export const MIN_SUCCESSFUL_PINGS = 10;

export function pingHost(pingUrl, successCallback, errorCallback) {
  return new Promise((resolve) => {
    function pingHostRecursive(pingAttemptCount = 0, successCount = 0) {
      const failureCallback = () => {
        if (pingAttemptCount + 1 < MAX_PING_ATTEMPTS) {
          // try again PING_DELAY_IN_MS/1000 seconds
          setTimeout(
            // increment pingAttemptCount, reset successCount
            () => {
              pingHostRecursive(pingAttemptCount + 1, 0);
            },
            PING_DELAY_IN_MS,
          );
        }
      };

      const successCounterCallback = () => {
        if (successCount + 1 >= MIN_SUCCESSFUL_PINGS) {
          successCallback();
          resolve();
        } else {
          setTimeout(
            // increment pingAttemptCount, increment successCount
            () => {
              pingHostRecursive(pingAttemptCount + 1, successCount + 1);
            },
            PING_DELAY_IN_MS,
          );
        }
      };

      if (pingAttemptCount + 1 >= MAX_PING_ATTEMPTS) {
        // After MAX_PING_ATTEMPTS attempts/failures, execute errorCallback
        errorCallback();
        resolve();
      }

      fetch(pingUrl).then(successCounterCallback).catch(failureCallback);
    }

    pingHostRecursive();
  });
}

/*
 * Function to generate pingable URL from a provisioning instance URL
 */
export function getPingUrl(redirectUrl) {
  const parser = document.createElement('a');
  parser.href = redirectUrl;
  // parser.origin does not work in all versions of IE
  const pingUrl = `${parser.protocol}//${parser.host}/ping`;

  return pingUrl;
}
